import { render, staticRenderFns } from "./FinancialEco.vue?vue&type=template&id=48f99128&"
import script from "./FinancialEco.vue?vue&type=script&lang=js&"
export * from "./FinancialEco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports